<template lang="pug">
#modal-sucesso-processamento-lote-ar
    el-dialog.modal-sucesso-processamento-lote-ar(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        append-to-body,
        custom-class='modal-sucesso-processamento-lote-ar-content',
        width='90%',
        @close='fecharModal'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.titulo') }}

        .modal-sucesso-processamento-lote-ar__body
            el-alert(
                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.descricao")',
                type='info',
                show-icon,
                :closable='false'
            )

            el-table.contratos-table(
                :data='contratos',
                border,
                stripe,
                style='width: 100%'
            )
                el-table-column(label='Nº Linha', width='80', align='center')
                    template(slot-scope='scope') {{ scope.row.numeroLinha || '-' }}

                el-table-column(label='Nº Ticket Salida', min-width='160')
                    template(slot-scope='scope') {{ scope.row.numeroTicketSalida || '-' }}

                el-table-column(label='Nº Carta Porte', min-width='150')
                    template(slot-scope='scope') {{ scope.row.numeroCartaPorte || '-' }}

                el-table-column(label='Código Interno', min-width='140')
                    template(slot-scope='scope') {{ scope.row.codigoInterno || '-' }}

                el-table-column(label='TN Descargados', min-width='140', align='right')
                    template(slot-scope='scope') {{ scope.row.tnDescargadosPuertos || '-' }}

                el-table-column(label='Status Vínculo', min-width='140', align='center')
                    template(slot-scope='scope')
                        el-tag(
                            :type='scope.row.idTerritorio ? "success" : "warning"',
                            size='small'
                        ) {{ scope.row.idTerritorio ? 'Vinculado' : 'Pendente' }}

        footer.modal-sucesso-processamento-lote-ar__footer(slot='footer')
            el-button(
                @click='fecharModal',
                :disabled='carregando'
            ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.fechar') }}
            el-button(
                type='primary',
                :loading='carregando',
                @click='confirmar'
            ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
export default {
    name: 'ModalSucessoProcessamentoLoteAr',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        contratos: {
            type: Array,
            default: () => []
        },
        carregando: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        confirmar() {
            if (this.carregando) {
                return;
            }

            this.$emit('confirmar');
        },

        fecharModal() {
            if (this.carregando) {
                return;
            }

            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
.modal-sucesso-processamento-lote-ar-content {
    max-width: 1280px;

    .el-dialog__header {
        padding: 16px 20px;
        background: var(--primary) !important;
        color: var(--white);
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: var(--white);
    }

    .el-dialog__body {
        padding: 20px;
        word-break: break-word;
    }

    .modal-sucesso-processamento-lote-ar__body {
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-height: 70vh;
        overflow-y: auto;
        padding-right: 4px;
    }

    .modal-sucesso-processamento-lote-ar__footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .contratos-table {
        border-bottom: 1px solid #ebeef5;
    }
}

@media (max-width: 900px) {
    .modal-sucesso-processamento-lote-ar-content {
        width: 96% !important;
    }
}
</style>
